import styled from 'styled-components';
import { IC_RIGHT_ARROW, IC_RIGHT_ARROW_WHITE, IC_DELIVERY_TRUCK } from '../../Assets/images';

export const AllUpcomingOrdersStyled = styled.div`


  .container {
    padding: 32px 10px;
    @media (max-width: 430px) {
      margin-top: 50px;
    }
    @media (max-width: 360px) {
      margin-top: 50px;
    }

  }

  .appUpcomingOrdersSlider {
    margin-bottom: 40px;
    .item {
      padding: 0 6px;

      .appointmentBox {
        width: 100%;
        border: 1px solid ${(props) => props?.theme?.color?.borderLight};
        background: ${(props) => props?.theme?.color?.white};
        border-radius: 8px;
        overflow: hidden;
        min-height: 227px;

        .dateAndTime {
          width: 100%;
          height: 40px;
          background: ${(props) => props?.theme?.blue?.extraLight};
          border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
          padding: 9px 12px;
          display: flex;
          justify-content: space-between;

          .dateTime {
            position: relative;
            display: flex;
            font-size: 13px;
            font-weight: 600;

            .date {
              padding: 0 20px 0 0;
              position: relative;

              &::after {
                content: '';
                width: 6px;
                height: 6px;
                background: ${(props) => props?.theme?.blue?.grey};
                border-radius: 50%;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
              }
            }
            .time {
              margin: 0 0 0 15px;
            }
          }
          .status {
            font-size: 13px;
            font-weight: 600;
            color: ${(props) => props?.theme?.color?.white};
          }

          &.core {
            color: ${(props) => props?.theme?.color?.white};
            background: ${(props) => props?.theme?.blue?.light};
            border-bottom-color: ${(props) => props?.theme?.blue?.light};

            .date {
              &::after {
                background: ${(props) => props?.theme?.color?.white};
              }
            }
          }

          &.ePharmacy {
            color: ${(props) => props?.theme?.color?.white};
            background: ${(props) => props?.theme?.green?.light};
            border-bottom-color: ${(props) => props?.theme?.green?.light};
            align-items: center;

            .orderID {
              width: 100%;
              padding-right: 5px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }

            .arrow {
              width: 7px;
              min-width: 7px;
              height: 12px;
              background: url(${IC_RIGHT_ARROW_WHITE.src}) no-repeat 50% 50% / cover;
            }
          }
        }

        .productAndPrice {
          padding: 13px 0;
          margin: 0 16px;
          border-bottom: 1px solid ${(props) => props?.theme?.grey?.iconBg};
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          .name {
            max-width: 100%;
            font-size: 15px;
            font-weight: 600;
            padding-right: 10px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .price {
            font-size: 18px;
            font-weight: 700;
            white-space: nowrap;
          }
        }

        .patientName {
          max-width: 100%;
          font-size: 15px;
          font-weight: 600;
          padding: 16px 0;
          margin: 0 16px;
          border-bottom: 1px solid ${(props) => props?.theme?.grey?.iconBg};
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .doctorDetails {
          width: 100%;

          .doctorInfo {
            padding: 14px 15px 13px 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .profilePic {
              min-width: 60px;
              width: 60px;
              height: 60px;
              background-position: 50% 50%;
              background-size: contain;
              background-repeat: no-repeat;
              margin-right: 12px;
              border-radius: 50%;
              overflow: hidden;
            }

            .consultWith {
              width: calc(100% - 89px);
              .name {
                width: 100%;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
              .type {
                width: 100%;
                color: ${(props) => props?.theme?.text?.medium};
                font-size: 13px;
                font-weight: 600;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }
            .arrow {
              width: 7px;
              min-width: 7px;
              height: 12px;
              background: url(${IC_RIGHT_ARROW.src}) no-repeat 50% 50% / cover;
            }
          }
        }

        .deliveryDetails {
          width: 100%;
          padding-right: 16px;
          border-bottom: 1px solid ${(props) => props?.theme?.grey?.iconBg};
          display: flex;
          justify-content: space-between;
          align-items: center;

          .deliveryInfo {
            background: url(${IC_DELIVERY_TRUCK.src}) no-repeat 16px 50% / 26px;
            margin: 8px 0;
            padding-left: 62px;

            .dLabel {
              color: ${(props) => props?.theme?.text?.medium};
              font-size: 15px;
              font-weight: 600;
            }
            .dValue {
              color: ${(props) => props?.theme?.text?.dark};
              font-size: 15px;
              font-weight: 600;
            }
          }

          .status {
            height: auto;
            .verification-status {
              height: auto;
              font-size: 12px;
              padding: 4px 8px;
              margin: 0;
              border-radius: 4px;
            }
          }
        }

        .otherInfo {
          width: 100%;
          height: 64px;
          color: ${(props) => props?.theme?.text?.medium};
          font-size: 14px;
          line-height: 18px;
          font-weight: 600;
          padding: 14px 16px;
          overflow: hidden;

          .more {
            color: ${(props) => props?.theme?.green?.dark};
            padding-left: 15px;
          }
        }

        .consultType {
          width: 100%;
          padding: 0 15px 15px 15px;
          display: flex;
          align-items: center;

          .ic {
            margin-right: 12px;
            display: flex;

            img {
              border-radius: 0;
            }
          }

          .text {
            font-size: 14px;
            font-weight: 400;
          }
        }
      }
    }
  }
  .slick-track {
    margin: 0;
  }
  @media (max-width: 820px) {
    .container {
      padding: 15px 10px;
    }
    .title {
      margin: 0 0 15px 10px;
    }

    .slick-list {
      width: 100% !important;
      margin: 0 !important;
      .slick-track {
        margin: 0;
      }
    }
  }
  @media (max-width: 480px) {
    .appUpcomingOrdersSlider {
      .item {
        .appointmentBox {
          .deliveryDetails {
            .deliveryInfo {
              padding-left: 42px;
              background-size: 20px;

              .dLabel {
                font-size: 13px;
              }
            }

            .status {
              .verification-status {
                font-size: 11px;
              }
            }
          }
        }
      }
    }
    .slick-slide {
      width: 90vw !important;
    }
  }
`;
